import React, { useEffect, useState } from "react";
// === UI ===
import { Center, Text } from "native-base";
import { View, Image } from "react-native";
import ActionSheet from "../nativeBase-ui/ActionSheet";

import * as ExpoSplashScreen from "expo-splash-screen";
import * as CONSTS from "../../assets/consts";
// === Redux ===
import * as AppActions from "../actions/AppActions";
import { batch, useDispatch, useSelector } from "react-redux";
// === Components ===
import * as SecureStore from "../components_v2/DeviceAsyncStorage";
import UserProfile from "../components/UserProfile";
import { translate } from "../locales/translate";
// === Models ===
import BuildingInfo from "../viewModels/BuildingInfo";
import ServerInfo from "../viewModels/ServerInfo";
// === Modules ===
import CacheStorage from "../modules/cacheStorage";
import Loading from "../components/Loading";
import fetchUserBuildings from "../hooks/fetchUserBuildings";
import { onFirebaseHandler } from "../modules/firebaseHandler/onFirebaseHandler";
// === Modules ===
const LOGO_SIZE = 200;
interface Props {
  navigation: any;
}
interface ConnectionData {
  // buildings: BuildingInfo[];
  currentBuilding: BuildingInfo;
  // servers: ServerInfo[];
  currentServer: ServerInfo;
  cachedBuildings: any;
}

const WelcomeScreen = (props: Props) => {
  const [loading, setLoading] = useState(true);
  const { navigation } = props;
  const [onOpenActionSheet, setOnOpenActionSheet] = useState(false);
  const [buildingsList, setBuildingsList] = useState<BuildingInfo[] | []>([]);

  const dispatch = useDispatch();
  const AppReducer = useSelector((state: any) => state.AppReducer);

  // const AppState=useSelector
  useEffect(() => {
    getConnectionData().then((result) => {
      ExpoSplashScreen.hideAsync();
      checkInitialConnectionData(result);
    });
  }, []);
  const getConnectionData = async () => {
    // === get buildings ===
    // const buildings = AppReducer.buildings;
    // === get current Building ===
    const currentBuilding = AppReducer.currentBuilding;
    // === get servers ===
    // const servers = AppReducer.servers;
    // === get current servers ===
    const currentServer = AppReducer.currentServer;
    // === get cache buildings ===
    var cachedBuildings = await new CacheStorage().buildings.GetAll();

    // console.log("building", buildings);
    // console.log("currentBuilding", currentBuilding);
    // console.log("sevres", servers);
    // console.log("currentServer", currentServer);
    // console.log("cachedBuildings", cachedBuildings);
    // console.log(props);

    return {
      currentBuilding,
      currentServer,
      cachedBuildings,
    };
  };

  const checkInitialConnectionData = async (connectionData: ConnectionData) => {
    const { currentBuilding, currentServer, cachedBuildings } = connectionData;
    if (cachedBuildings.length !== 0) {
      var localServers: ServerInfo[] = [];
      var localBuildings: BuildingInfo[] = [];
      var localCurrentBuilding: BuildingInfo | any = {};
      for (let item in cachedBuildings) {
        const building = cachedBuildings[item];
        const newBuildingModel = new BuildingInfo(
          building.buildingId,
          building.serverId,
          null,
          building.localAddress,
          building.buildingName,
          building.modules || [],
          ""
        );
        localBuildings.push(newBuildingModel);
        var relatedServer = localServers.find((server) => {
          server.serverId == newBuildingModel.serverId;
        });
        const buildingIdSecure = await SecureStore.getBuildingId();
        if (buildingIdSecure && buildingIdSecure === building.buildingId) {
          localCurrentBuilding = newBuildingModel;
        }
        if (relatedServer) {
          if (!relatedServer.accessToken) {
            const accessToken = await SecureStore.getAccessToken(
              building.buildingId
            );
            if (accessToken) {
              relatedServer.accessToken = accessToken;
            }
          }
        } else {
          const accessToken = await SecureStore.getAccessToken(
            building.buildingId
          );
          const newServerModel = new ServerInfo(
            building.serverId,
            building.publicAddress || null,
            building.localAddress || null,
            accessToken,
            building.userDisplayName,
            building.userId,
            CONSTS.DEFAULT_PORTS_BRAND
          );
          localServers.push(newServerModel);
        }
      }
      // === clear duplicate server ===
      localServers = localServers.filter(
        (elem, index, self) =>
          self.findIndex((t) => {
            return t.serverId === elem.serverId;
          }) === index
      );
      batch(() => {
        dispatch(AppActions.setBuildings(localBuildings));
        dispatch(AppActions.setServers(localServers));
      });

      if (localCurrentBuilding) {
        dispatch(AppActions.updateCurrentBuilding(localBuildings));
        SecureStore.Servers.getAccessToken(localCurrentBuilding.serverId).then(
          (token) => {
            if (token) {
              SecureStore.setAccessToken(
                localCurrentBuilding.buildingId,
                token
              );
              dispatch(
                AppActions.ForceInit(token, localCurrentBuilding.buildingId)
              );
              navigation.replace("Home");
            }
            new CacheStorage().buildings.ClearAll();
          }
        );
        SecureStore.Servers.getCurrentServer()
          .then((server: ServerInfo) => {
            dispatch(AppActions.updateCurrentServer(server));
          })
          .catch((error) => console.log("error in setBuildings", error));
      }
    } else if (currentBuilding && Object.keys(currentBuilding).length > 0) {
      const { serverId, cloudServerId, buildingId } = currentBuilding;
      // === Access Token ===
      var access_token: string | null = null;
      const accessTokenCloud = await SecureStore.Servers.getAccessToken(
        cloudServerId
      );
      const accessTokenMaster = await SecureStore.Servers.getAccessToken(
        serverId
      );
      if (accessTokenCloud) {
        access_token = accessTokenCloud;
      } else if (accessTokenMaster) {
        access_token = accessTokenMaster;
      }
      if (
        access_token &&
        (AppReducer.serverUrl || currentServer.publicAddress)
      ) {
        const { buildings: fetchBuildings, servers } = await fetchUserBuildings(
          access_token,
          AppReducer.serverUrl || currentServer?.publicAddress
        );
        SecureStore.setAccessToken(buildingId, access_token);
        batch(() => {
          dispatch(AppActions.setBuildings(fetchBuildings));
          dispatch(AppActions.setServers(servers));
          dispatch(AppActions.updateCurrentBuilding(currentBuilding));
          dispatch(AppActions.updateCurrentServer(currentServer));
          dispatch(AppActions.ForceInit(access_token || "", buildingId));
        });

        // === FirebaseHandler ===
        onFirebaseHandler(dispatch, access_token);
        navigation.replace("Home");
      } else {
        navigation.replace("Login");
      }
    } else if (currentServer) {
      dispatch(AppActions.updateCurrentServer(currentServer));
      if (currentServer.accessToken && currentServer?.accessToken !== "") {
        dispatch(AppActions.ForceInit(currentServer.accessToken, ""));
        // === FirebaseHandler ===

        const { buildings } = await fetchUserBuildings(
          currentServer?.accessToken,
          AppReducer.serverUrl || currentServer?.publicAddress
        );
        if (buildings?.length !== 0) {
          dispatch(AppActions.setBuildings(buildings));
        }
        if (buildings && buildings.length > 1) {
          setOnOpenActionSheet(true);
          setBuildingsList(buildings);
        } else if (buildings?.length == 1) {
          dispatch(AppActions.updateCurrentBuilding(buildings[0]));
          onProfileSelect(buildings[0]);
        } else if (buildings?.length === 0) {
          batch(() => {
            dispatch(AppActions.updateCurrentBuilding({}));
            dispatch(AppActions.setBuildings([]));
          });
          navigation.replace("Home");
        }
      } else {
        navigation.replace("Login");
      }
    } else {
      navigation.replace("Login");
    }
  };
  const onProfileSelect = (profile: BuildingInfo) => {
    const { navigation } = props;
    dispatch(AppActions.updateCurrentBuilding(profile));
    SecureStore.Servers.getAccessToken(
      profile.cloudServerId || profile.serverId
    ).then((token) => {
      if (token) {
        onFirebaseHandler(dispatch, token);
        dispatch(AppActions.ForceInit(token, profile.buildingId));
        navigation.replace("Home");
      }
    });
  };
  if (loading) {
    return (
      <>
        {onOpenActionSheet ? (
          <Center flex={1}>
            <Image
              source={CONSTS.BRANDING.LOGO_TYPE}
              style={{
                resizeMode: "contain",
                width: LOGO_SIZE,
                height: LOGO_SIZE / 2,
              }}
            />
          </Center>
        ) : (
          <Loading />
        )}
        {onOpenActionSheet && (
          <ActionSheet
            isOpen={onOpenActionSheet}
            header={translate("user_profile.pickAProfile")}
          >
            {buildingsList.length > 0 &&
              buildingsList.map((b: any, i: any) => {
                return (
                  <UserProfile
                    key={i}
                    style={{ marginVertical: 5 }}
                    buildingId={b.buildingId}
                    buildingName={b.buildingName}
                    userId={b.userId}
                    userFullName={b.userDisplayName}
                    serverId={b.serverId}
                    selected={false}
                    onSelect={() => {
                      setOnOpenActionSheet(false);
                      onProfileSelect(b);
                    }}
                  />
                );
              })}
          </ActionSheet>
        )}
      </>
    );
  } else {
    return (
      <View>
        <Text>empty screen</Text>
      </View>
    );
  }
};

export default WelcomeScreen;
